var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 16.875,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1452 27.4531V25.8385C26.1452 24.9821 25.805 24.1608 25.1994 23.5552C24.5938 22.9496 23.7724 22.6094 22.916 22.6094H16.4577C15.6013 22.6094 14.7799 22.9496 14.1743 23.5552C13.5687 24.1608 13.2285 24.9821 13.2285 25.8385V27.4531",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6882 19.3802C21.4716 19.3802 22.9173 17.9345 22.9173 16.151C22.9173 14.3676 21.4716 12.9219 19.6882 12.9219C17.9047 12.9219 16.459 14.3676 16.459 16.151C16.459 17.9345 17.9047 19.3802 19.6882 19.3802Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7da5abf8080b10d8d3cb8b86dbecd2c1.svg";
export { ForwardRef as ReactComponent };